import React from 'react';
import useExplore from '../hooks/useExplore';
import ExploreChoiceCard from './ExploreChoiceCard';

export default function ExploreQuestion({ questionKey, title, options, multi = false }) {
  const { state, setAnswer } = useExplore();
  const current = state.answers?.[questionKey] || (multi ? [] : '');

  const toggle = (value) => {
    if (!multi) return setAnswer(questionKey, value);
    const set = new Set(current);
    if (set.has(value)) set.delete(value);
    else set.add(value);
    setAnswer(questionKey, Array.from(set));
  };

  return (
    <section className="explore-question">
      <h2>{title}</h2>
      <div className="explore-choice-grid">
        {options.map((option) => {
          const selected = multi ? current.includes(option.value) : current === option.value;
          return (
            <ExploreChoiceCard
              key={option.value}
              icon={option.icon}
              title={option.label}
              description={option.description}
              selected={selected}
              onClick={() => toggle(option.value)}
            />
          );
        })}
      </div>
    </section>
  );
}
